import React from "react";
import PropTypes from "prop-types";
import img1 from "./img/Recurso1.png";
import img2 from "./img/Recurso2.png";
import img3 from "./img/Recurso3.png";
import img4 from "./img/Recurso4.png";
import img5 from "./img/Recurso5.png";
import img6 from "./img/Recurso6.png";

import "./styles/style.scss";
import "./styles/animaciones.scss";
import Stars from "./Stars";

const Logo = ({ className, title, subtitle }) => {
  return (
    <div className={`glc-logo-container ${className}`}>
      <div className="glc-logo-image">
        <div className="glc-logo-galaxy">
          <img className="glc-logo-planet" src={img6} alt="01" />
          <div className="glc-logo-shade"></div>
          <div className="glc-logo-stars">
            <Stars />
          </div>

          <div className="glc-logo-images">
            <img className="glc-logo-image5" src={img5} alt="01" />
            <img className="glc-logo-image4" src={img4} alt="01" />
            <img className="glc-logo-image3" src={img3} alt="01" />
            <img className="glc-logo-image2" src={img2} alt="01" />
            <img className="glc-logo-image1" src={img1} alt="01" />
          </div>
          <div className="glc-logo-dot"></div>
        </div>
      </div>
      <div className="glc-logo-texto">
        <p className="glc-logo-texto-CW">
          <span>C</span>
          <span>e</span>
          <span>n</span>
          <span>t</span>
          <span>e</span>
          <span>r</span>
          <span>W</span>
          <span>a</span>
          <span>r</span>
          <span>e</span>
        </p>
        <p className="glc-logo-texto-KB">{title}</p>
        <p className="glc-logo-texto-AGT">{subtitle}</p>
      </div>
    </div>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.jsx